<template>
  <div class="content">
    <div class="content__row">
      <div class="content__column content__column--wide">
        <h1 class="content__title">Tipos de descuento</h1>
      </div>
    </div>
    <div class="content__row">
      <type-list :filters="filters"></type-list>
      <type-view :type="type" v-if="typeAction === 'view' && type"></type-view>
      <div class="content__column content__column--small">
        <h1 class="content__title">Opciones</h1>
        <div class="information">
          <h2 class="content__subtitle">Navegación</h2>
          <router-link class="btn btn__action btn--small" :to="{name: 'productView'}">Productos</router-link>
          <h2 class="content__subtitle">Filtro</h2>
          <div class="form__container">
            <label for="search" class="form__label">búsqueda Libre</label>
            <input type="text" name="search" id="search" class="form__input" v-model="search" @keyup="setFilters">
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import httpService from '@/core/api/request'
import typeList from './list'
import typeView from './view'
export default {
  mixins: [
    httpService
  ],
  components: {
    typeList,
    typeView
  },
  data: function () {
    return {
      key: 0,
      search: null,
      filters: undefined,
      typeAction: null,
      type: null
    }
  },
  mounted: function () {
    this.$on('view',id => {
      this.getType(id, 'view')
    })
  },
  methods: {
    setFilters: function () {
      let filter = ''
      if (this.search && this.search.length > 1) {
        filter = 'search=' + this.search
      }
      if (filter.length > 0) {
        this.filters = filter
      } else {
        this.filters = undefined
      }
    },
    getType: function (id, action) {
      this.typeAction = action
      let httpRequest = {
        params: '',
        module: 'discount_types'
      }
      this.getById(id, httpRequest)
        .then(
          type => {
            this.type = type.data
          }
        )
    }
  }
}
</script>

<style lang="sass">
  @import "../../assets/sass/components/_home"
  @import "../../assets/sass/components/_forms"
</style>



// WEBPACK FOOTER //
// src/components/discount_types/types.vue